import { Component, OnInit } from '@angular/core';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationStart,
  RouteConfigLoadEnd,
  RouteConfigLoadStart,
  Router,
  RouterEvent,
  RouterOutlet
} from '@angular/router';

import { MessageService } from 'primeng/api';
import { filter } from 'rxjs';

import { NetworkFunctions, SummitDisposing } from '@summit/models';
// Moved AG Grid and Charts license managers to lazy initialization
// import { LicenseManager as AGChartLicenseManager } from 'ag-charts-enterprise';
// import { LicenseManager as AGLicenseManager } from 'ag-grid-enterprise';

import { NotificationItemComponent } from '@summit/services';
import { Button } from 'primeng/button';
import { Toast } from 'primeng/toast';
import { colorConsole, debugBuild } from '../app-debug';
import { UserExperience } from './models/ebo/shared/user-experience';
import { AuthenticationService } from './services/authentication/authentication.service';
import { UpdateService } from './services/update.service';
import { UserExperienceService } from './services/user-experience.service';

// const responsiveOptions: ResponsiveOverlayOptions = {
//   // style?: any;                                     // Style of component in given breakpoint or media query
//   // styleClass?: string;                             // Style class of component in given breakpoint or media query
//   // contentStyle?: any;                              // Style of content in given breakpoint or media query
//   // contentStyleClass?: string;                      // Style class of content in given breakpoint or media query
//   // breakpoint?: string;                             // Breakpoint required to show component in modal mode. Exp: '640px', '10rem' etc.
//   // media?: string;                                  // Media query required to show component in modal mode. Exp: '@media screen and (max-width: 640px)', '@media screen and (min-width: 640px) and (max-width: 900px)' etc.
//   direction: 'center' // Direction in which the component will be displayed in modal mode.
// };
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [NotificationItemComponent, RouterOutlet, Toast, Button]
})
export class AppComponent extends SummitDisposing implements OnInit {
  title = 'EBO Pro';
  ux: UserExperience;
  isShowingRouteLoadIndicator: boolean;
  // defaultIcon = DefaultIcon;
  constructor(
    //    private primengConfig: PrimeNGConfig,
    protected uxService: UserExperienceService,
    private authService: AuthenticationService,
    private messageService: MessageService,
    protected updateService: UpdateService, // need to start the update service, do not comment out
    public router: Router
  ) {
    super();
    
    // AG Grid license initialization moved to AgGridLicenseService 
    // to prevent loading heavy libraries in main bundle
    
    /*
    Animations for lazy load components
    https://www.bennadel.com/blog/3505-showing-a-loading-indicator-for-lazy-loaded-route-modules-in-angular-6-1-7.htm
    */
    this.isShowingRouteLoadIndicator = false;
    // As the router loads modules asynchronously (via loadChildren), we're going to
    // keep track of how many asynchronous requests are currently active. If there is
    // at least one pending load request, we'll show the indicator.
    let asyncLoadCount = 0;
    let userClicked = false;
    // The Router emits special events for "loadChildren" configuration loading. We
    // just need to listen for the Start and End events in order to determine if we
    // have any pending configuration requests.
    router.events.pipe(filter((event) => event instanceof RouterEvent)).subscribe((event) => {
      if (event instanceof RouteConfigLoadStart) {
        asyncLoadCount++;
      } else if (event instanceof RouteConfigLoadEnd) {
        asyncLoadCount--;
      } else if (event instanceof NavigationStart) {
        //console.warn(`Router ${(event as RouterEvent).url.toString()}`, event);
        userClicked = true;
      } else if (event instanceof NavigationEnd) {
        //console.warn(`Router ${(event as RouterEvent).url.toString()}`, event);
        userClicked = false;
      } else if (event instanceof NavigationCancel) {
        userClicked = false;
      } else {
        //console.log('[APP] Unhandled Router event: ', event);
      }

      // If there is at least one pending asynchronous config load request,
      // then let's show the loading indicator.
      // --
      // CAUTION: I'm using CSS to include a small delay such that this loading
      // indicator won't be seen by people with sufficiently fast connections.

      // User clicked was added to avoid dialog popping for background loading

      this.isShowingRouteLoadIndicator = !!asyncLoadCount && userClicked;

      if (this.isShowingRouteLoadIndicator) {
        //Check to see if Network Speed has improved, if so, preload everything
        // console.log('Testing to see if there is a good connection')
        if (NetworkFunctions.hasGoodConnection()) {
          // console.log('Good Connection, preloading everything');
          //this.uxService.preLoadBasedOnUx(null, true);
        }
      }
    });
  }
  ngOnInit() {
    //BuildDebug
    //    this.primengConfig.ripple = true;
    if (debugBuild) colorConsole(`----> EBOPro INIT <----`);
    this.authService.validateTokenIfPresent();
    // this.primengConfig.overlayOptions = {
    //   mode: 'overlay',
    //   responsive: responsiveOptions
    // };
    //keeping stuff under 999 since that is where the time picker pops
    // this.primengConfig.zIndex = {
    //   modal: 900, // dialog, sidebar
    //   overlay: 800, // dropdown, overlaypanel
    //   menu: 800, // overlay menus
    //   tooltip: 900 // tooltip
    // };
  }

  // test() {
  //   console.log('button worked');
  // }
}
